import { twMerge } from "tailwind-merge";
import { Button, Card } from "@sellar-io/components";
import { useForm, useWatch } from "react-hook-form";
import { Icon } from "../../../components";
import { useEvents } from "../../../hooks";
import { useOrderCommentCreate } from "../../../hooks/api/v2/orderComment/useOrderCommentCreate";
import { usePaymentLinkOrderCommentCreate } from "../../../hooks/api/v2/paymentLink/usePaymentLinkOrderCommentCreate";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { ChatInput } from "../../../components/chatInput/ChatInput";

export const OrderSendMessageForm = ({
  orderId,
  onFocus,
  onBlur,
  mutation,
}: {
  orderId: number;
  onFocus?: () => void;
  onBlur?: () => void;
  mutation: ReturnType<
    typeof useOrderCommentCreate | typeof usePaymentLinkOrderCommentCreate
  >;
}) => {
  const form = useForm({
    defaultValues: {
      message: "",
    },
  });
  const { track } = useEvents();
  const { business } = useSellarCurrentBusiness();
  const message = useWatch({
    control: form.control,
    name: "message",
  });
  const onSubmit = () => {
    if (!message) return;
    mutation.mutate(
      {
        OrderId: orderId,
        message,
      },
      {
        onSuccess: () => {
          form.reset();
          track("Comment Created", {
            businessName: business?.name,
            message,
            kind: "comment",
          });
        },
      },
    );
  };
  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <Card
        className={twMerge("bg-white", "flex flex-row items-end gap-2 p-4")}
      >
        <ChatInput
          {...form.register("message")}
          value={message}
          setValue={(val) => form.setValue("message", val)}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder="Add a comment"
        />
        <div>
          <Button
            className={"h-auto"}
            type={"submit"}
            disabled={!message || mutation.isPending}
          >
            <Icon icon={"SEND"} />
          </Button>
        </div>
      </Card>
    </form>
  );
};
